<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/contacts/overview']">Zur Übersicht</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/contacts/customer']">Kunden</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/contacts/suppliers']">Lieferanten</a>
    </li>
  </ul>
</nav>
<main *ngIf="company">
  <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Kontaktdetails <cds-icon shape="two-way-arrows"></cds-icon> {{ companyId }}</h2>
  <button *ngIf="!company.active" class="btn btn-warning">PASSIV!</button>

  <div class="clr-row" >
    <div class="clr-col-6">
      <div class="card">
        <div class="card-header">
          Firma <cds-icon shape="two-way-arrows"></cds-icon>  {{ company.company }}
        </div>
        <div class="card-block">
          <div class="card-text">
            <table class="table table-vertical">
              <tbody>
              <tr>
                <th>ID</th>
                <td>{{ company.cid }}</td>
              </tr>
              <tr *ngIf="crmMode">
                <th>CRM-ID</th>
                <td>
                  <span>{{ crmId || '-' }} </span>
                  <span *ngIf="crmIdStatus" class="label label-sm"> {{ crmIdStatus }}</span>
                </td>
              </tr>
              <tr>
                <th>Firma (Klassifizierung)</th>
                <td>{{ company.company }} <b>({{ company.classification }})</b></td>
              </tr>
              <tr>
                <th>Abteilung</th>
                <td>{{ company.department }}</td>
              </tr>
              <tr>
                <th>Adresse</th>
                <td>{{ company.street }}<br>{{ company.postcode }} {{ company.city }}</td>
              </tr>
              <tr>
                <th>Bundesland</th>
                <td>{{ company.region }}</td>
              </tr>
              <tr>
                <th>Land</th>
                <td>
                  <ng-container *transloco="let t; prefix: 'countries'">
                    {{ company.country?.length === 2 ? t(company.country ?? '') : (company.country ?? '') }}
                  </ng-container>
                </td>
              </tr>
              <tr>
                <th>Telefon</th>
                <td nowrap (click)="makeACall = true">{{ company.phone }}</td>
              </tr>
              <tr>
                <th>E-Mail</th>
                <td>{{ company.email }}</td>
              </tr>
              <tr>
                <th>Lieferbedingungen</th>
                <td>{{ delivery }}</td>
              </tr>
              <tr>
                <th>Zahlungsbedingungen</th>
                <td>{{ payment }}</td>
              </tr>
              <tr>
                <th>Website</th>
                <td>{{ company.website }}</td>
              </tr>
              <tr>
                <th>Leitweg-ID (XRechnung)</th>
                <td>{{ company.leitweg_id }}</td>
              </tr>
              <tr>
                <th>E-Invoice Endpoint</th>
                <td>{{ company.einvoice_endpoint }}</td>
              </tr>
              <tr>
                <th>Bankverbindung</th>
                <td>{{ company.bankname }}<br>IBAN&nbsp;{{ company.iban }}<br />BIC&nbsp;{{ company.bankcode }}</td>
              </tr>
              <tr>
                <th>Steuernummer</th>
                <td>{{ company.tax_id }}</td>
              </tr>
              <tr>
                <th>USt-IdNr.</th>
                <td>{{ company.vat_id }}</td>
              </tr>
              <tr>
                <th>Kontakttyp</th>
                <td>{{ company.contact_type || company.type }}</td>
              </tr>
              <tr>
                <th>Bemerkungen</th>
                <td>{{ company.notes }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card-footer">
          <button *ngIf="!devMode" class="btn btn-sm btn-link" [routerLink]="['/contact/update', company.cid ]">Bearbeiten</button>
          <button *ngIf="!devMode" class="btn btn-sm btn-link" (click)="deleteCompany(company.cid, company.company)">Löschen</button>
        </div>
      </div>
    </div>
    <div class="clr-col-6">
      <div class="card" *ngIf="crmMode">
        <div class="card-header">
          CRM Sync
        </div>
        <div class="card-block">
          <div class="card-text">
            <table class="table table-vertical">
              <tbody>
              <tr>
                <th>Status</th>
                <td><span [class]="crmCompareClass">{{ crmCompareLabel }}</span></td>
              </tr>
              <tr>
                <th>CRM-ID</th>
                <td>{{ crmCompare?.crm_id ?? '-' }}</td>
              </tr>
              <tr>
                <th>Sync-State</th>
                <td>{{ crmCompare?.crm_sync_state ?? '-' }}</td>
              </tr>
              <tr>
                <th>Letzter Sync</th>
                <td>{{ crmCompare?.crm_sync_at ?? '-' }}</td>
              </tr>
              <tr>
                <th>Fehler</th>
                <td>{{ crmCompare?.crm_sync_error ?? '-' }}</td>
              </tr>
              <tr>
                <th>Compare Fehler</th>
                <td>{{ crmCompare?.compare_error ?? '-' }}</td>
              </tr>
              <tr>
                <th>Blocking Issues</th>
                <td class="crm-blocking-issues">
                  <span *ngIf="!crmCompare?.blocking_issues?.length">-</span>
                  <span *ngFor="let issue of crmCompare?.blocking_issues" class="label label-sm label-danger crm-issue-label">{{ issue }}</span>
                </td>
              </tr>
              <tr *ngIf="crmCompare?.diffs?.length">
                <th>Feldvergleich</th>
                <td>
                  <table class="table table-compact crm-diff-table">
                    <thead>
                    <tr>
                      <th>Feld</th>
                      <th>PPS</th>
                      <th>CRM</th>
                      <th>Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let diff of crmCompare?.diffs">
                      <td>{{ getDiffFieldLabel(diff.field) }}</td>
                      <td>{{ diff.pps || '-' }}</td>
                      <td>{{ diff.crm || '-' }}</td>
                      <td>
                        <span [class]="diff.equal ? 'label label-sm label-success' : 'label label-sm label-danger'">
                          {{ diff.equal ? 'gleich' : 'abweichend' }}
                        </span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              </tbody>
            </table>
            <div>
              <br>
              <button class="btn btn-sm btn-primary" (click)="syncCrmNow()" [disabled]="crmSyncRunning || crmCompareLoading">
                {{ crmSyncRunning ? 'Synchronisiere...' : 'Jetzt synchronisieren' }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <app-project-card [companyId]="companyId" [active]="company.active" [projectId]="'0'" [employeeLeader]=0></app-project-card>
      <app-request-card [companyId]="companyId"></app-request-card>
      <app-contact-files-card [companyId]="companyId"></app-contact-files-card>
      <app-persons-card [companyId]="companyId" ></app-persons-card>
    </div>
  </div>
</main>

<clr-modal *ngIf="company" [(clrModalOpen)]="makeACall" [clrModalStaticBackdrop]="false">
  <h3 class="modal-title">Möchten Sie {{ company.company }} anrufen?</h3>
  <div class="modal-body">
    <p><a [attr.href]="callUrl(company.phone)">{{ company.phone }}</a></p>
    <small>(Anruf wird an Telefonanlage übergeben)</small>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="makeACall = false">Abbrechen</button>
    <button type="button" class="btn btn-primary" (click)="startCall(company.phone)">JETZT ANRUFEN</button>
  </div>
</clr-modal>
